// src/pages/CompanyManagementPage.jsx
import React from 'react';
import CompanyManagement from '../features/companies/CompanyManagement';

const CompanyManagementPage = () => {
    return <CompanyManagement />;
};

export default CompanyManagementPage;